import { __assign } from "tslib";
var defaultSchema = {
    destructure: true,
    key: 'key',
    value: 'value',
};
var mapParser = function (options, nextParser) {
    if (options === void 0) { options = {}; }
    var _a = options.separator, separator = _a === void 0 ? '--' : _a, _b = options.schema, customSchema = _b === void 0 ? defaultSchema : _b;
    var schema = __assign(__assign({}, defaultSchema), customSchema);
    var getParser = function (key) {
        var _a;
        var isParserMap = nextParser && nextParser instanceof Object && !nextParser.parse;
        return isParserMap
            ? (_a = nextParser === null || nextParser === void 0 ? void 0 : nextParser[key]) !== null && _a !== void 0 ? _a : nextParser === null || nextParser === void 0 ? void 0 : nextParser['defaultParser']
            : nextParser;
    };
    var getParsedValue = function (key, value) {
        var parser = getParser(key);
        return (parser === null || parser === void 0 ? void 0 : parser.parse) ? parser.parse(value) : value;
    };
    var getStringValue = function (key, value) {
        var parser = getParser(key);
        return (parser === null || parser === void 0 ? void 0 : parser.stringify) ? decodeURIComponent(parser.stringify(value)) : value;
    };
    return {
        parse: function (data) {
            var _a, _b;
            if (typeof data !== 'string')
                return {};
            var _c = decodeURIComponent(data).split(separator), key = _c[0], _d = _c[1], value = _d === void 0 ? '' : _d;
            var parsedValue = getParsedValue(key, value);
            if (schema.destructure &&
                parsedValue instanceof Object &&
                !Array.isArray(parsedValue) &&
                Object.keys(parsedValue).length) {
                return __assign((_a = {}, _a[schema.key] = key, _a), parsedValue);
            }
            return _b = {},
                _b[schema.key] = key,
                _b[schema.value] = parsedValue,
                _b;
        },
        stringify: function (data, options) {
            if (options === void 0) { options = { encode: true }; }
            if (!data || Object.keys(data).length === 0)
                return '';
            var key = data[schema.key];
            delete data[schema.key];
            var valueToStringify = !data[schema.value] && Object.keys(data).length ? data : data[schema.value];
            var value = getStringValue(key, valueToStringify);
            if (options.encode) {
                return encodeURIComponent("".concat(key).concat(separator).concat(value !== undefined ? value : ''));
            }
            return "".concat(key).concat(separator).concat(value !== undefined ? value : '');
        },
    };
};
export default mapParser;
//# sourceMappingURL=map-parser.js.map